module.exports = __webpack_public_path__ + "assets/library-inactive.86a19f9b.svg";